import { GlobalConstantsTableCols } from "globales-projekt-angular";

export class ConstantsTableColsEmissionsquelle extends GlobalConstantsTableCols {
  static readonly GEWICHTUNGSFAKTOR: string = 'GEWICHTUNGSFAKTOR';
  static readonly EMISSION_GE: string = 'EMISSION_GE';
  static readonly X_KOORDINATE: string = 'X_KOORDINATE';
  static readonly Y_KOORDINATE: string = 'Y_KOORDINATE';
}
